import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatDate } from "../../../helpers/dateFormatter";

export const AuditTrailTable: React.FC<BaseTablePropsType> = ({ rows }) => {
    const auditTrailTableHeaders = ["System Activity", "Created By", "Branch", "Approved By", "Date & Time"];
    return (
        <BaseTable
            headers={auditTrailTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow
                            key={index}
                        >
                            <TableCell>{row?.systemActivity}</TableCell>
                            <TableCell>{row?.creatorName}</TableCell>
                            <TableCell>{row?.branch || "GLOBAL"}</TableCell>
                            <TableCell>{row?.approvedBy || "-"}</TableCell>
                            <TableCell>{formatDate(row?.createdAt, true)}</TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}